import { AnimatePresence } from "framer-motion";
import type { OnboardingTransitionProps } from "@medbillai/app/screens/onboarding/OnboardingFlow";
import { YStack } from "@medbillai/ui";
import PageTransition from "./PageTransition";
export const OnboardingPageTransition = ({
  stateKey,
  direction,
  children
}: OnboardingTransitionProps) => <AnimatePresence initial={false} mode="wait" data-sentry-element="AnimatePresence" data-sentry-component="OnboardingPageTransition" data-sentry-source-file="OnboardingPageTransition.tsx">
    <PageTransition key={stateKey} childKey={stateKey} direction={direction} data-sentry-element="PageTransition" data-sentry-source-file="OnboardingPageTransition.tsx">
      {/* motion.div is display:block — flex:1 on child YStacks collapses
          to content height; this wrapper anchors them to the full viewport. */}
      <YStack flex={1} height="100%" data-sentry-element="YStack" data-sentry-source-file="OnboardingPageTransition.tsx">
        {children}
      </YStack>
    </PageTransition>
  </AnimatePresence>;